export default {
  data() {
    return {};
  },

  mounted() { },

  methods: {
    machineGeneralizerText(machine) {
      var text = '';
      if (machine) {
        var model = machine.MachineModel;
        if (model) {
          if (model.MachineType) {
            text = model.MachineType.Name + ' ';
          }
          text = text + model.Name;
        }
        var assetType = machine.AssetType;
        if (assetType) {
          text = text + ' ' + assetType.Name;
        }
      }
      return text;
    },

    machineIdentifierText(machine) {
      var text = '';
      if (machine) {
        text = text + machine.Name;
        if (machine.SerialNumber || machine.Qrcode) {
          text = text + ' [';
          if (machine.SerialNumber) {
            text = text + machine.SerialNumber;
          }
          if (machine.SerialNumber && machine.Qrcode) {
            text = text + ', ';
          }
          if (machine.Qrcode) {
            text = text + machine.Qrcode;
          }
          text = text + ']';
        }
      }
      return text;
    },
  },

  computed: {

  },

  watch: {},
}